import { v4 as uuidv4 } from 'uuid';

interface StepDefinition {
  [key: string]: any;
  condition?: string | null;
}

class Step {
  type: string;
  id: string;
  description: string;
  definition: StepDefinition;

  constructor(type: string, description: string, definition: StepDefinition) {
    this.type = type;
    this.id = uuidv4().replace(/-/g, '_');
    this.description = description;
    this.definition = {
      ...definition,
      ...(definition.condition ? { condition: definition.condition } : {})
    };
  }

  toJson() {
    const cleanDefinition = { ...this.definition };
    
    // Ensure all required fields are present
    if (this.type === 'inference_chain') {
      cleanDefinition.prompt = cleanDefinition.prompt || '';
      cleanDefinition.variables = cleanDefinition.variables || {};
      cleanDefinition.is_streaming = cleanDefinition.is_streaming || false;
    }

    // Ensure code is included for code steps
    if (this.type === 'code') {
      cleanDefinition.code = cleanDefinition.code || '';
      cleanDefinition.variables = cleanDefinition.variables || {};
    }

    // Clean up variables
    if ('variables' in cleanDefinition) {
      cleanDefinition.variables = Object.keys(cleanDefinition.variables || {}).reduce((acc, key) => ({
        ...acc,
        [key]: cleanDefinition.variables[key] || ''
      }), {});
    }

    return {
      type: this.type,
      params: {
        id: this.id,
        description: this.description,
        definition: {
          ...cleanDefinition,
          ...(cleanDefinition.condition ? { condition: cleanDefinition.condition } : {})
        }
      }
    };
  }

  static fromJson(json: any): Step {
    const type = json.type || 'inference_chain';
    const description = json.params?.description || '';
    const definition = json.params?.definition || {};
    
    // Create a new definition without condition if it's empty or null
    const cleanDefinition = {
      ...definition,
      ...(definition.condition ? { condition: definition.condition } : {})
    };

    const step = new Step(type, description, cleanDefinition);
    if (json.params?.id) {
      step.id = json.params.id;
    }
    return step;
  }
}

export default Step;